import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { CookieService } from 'ngx-cookie-service';
import { ConstantsModule } from '../constants/constants.module';
import { DialogPage } from '../root_classes/dialog-page';
import { UserAddMinicompanyComponent } from './../user-add-minicompany/user-add-minicompany.component';

@Component({
  selector: 'app-user-add',
  templateUrl: './user-add.component.html',
  styleUrls: ['./user-add.component.scss']
})
export class UserAddComponent extends DialogPage implements OnInit {

	// Specific values if used with forced values.
	public _forceCompany = "";

  // Form data.
  userAddForm = new FormGroup({
    nameControl: new FormControl(''),
	firstnameControl: new FormControl(''),
	usernameControl: new FormControl('', [Validators.required, Validators.pattern(/.+@.+\..+/)]),
	roleControl: new FormControl('U', [Validators.required]),
	companyControl: new FormControl(''),
  });

  // All companies list.
  public companies: any[] = [];

  // Extra data.
  public buttonText: string;
  public enableAction: boolean;

  	constructor(constantsModule: ConstantsModule, cookieService: CookieService, httpClient: HttpClient, router: Router, modalService: NgbModal, modalInstance:NgbActiveModal) {
		super(constantsModule, cookieService, httpClient, router, modalService, modalInstance);

		// Save button infos.
		this.buttonText = "Ajouter";
		this.enableAction = true;
	}

  ngOnInit(): void {
	this.put("/api/company-list-names", undefined, 
		(response: any) => {
			if (response.DATA == "ERR") {
				switch (response.VALUE) {
					case "UNAUTHORIZED":
						this.alertLine.alertDangerMessage = "Vous ne disposez pas des droits pour accéder à ces données.";
						break;
					case "DATABASE":
						this.alertLine.alertDangerMessage = "Impossible de se connecter à la base de données. Contactez votre administrateur.";
						break;
					default:
						this.alertLine.alertDangerMessage = "Erreur inconnue (" + response.VALUE + "). Contactez votre administrateur.";
						break;
				}
			} else {
				this.companies = response.RES;

				// Forcing for a specific company.
				if (this._forceCompany != "") {
					this.userAddForm.controls["companyControl"].setValue(this._forceCompany);
					this.userAddForm.controls["companyControl"].disable();
				}
			}
		},
		(err: any) => {
			// Cannot load the data.
			this.alertLine.alertDangerMessage = "Impossible de se connecter au serveur (Erreur: " + this.httpErrorToText(err) + ").";
		}
	);
  }

	public setModalOptions(data:any): void {
		// This indicates, it is used inside another window.
		if (data["FROM"] == "COMPANY-DETAILS") {
			this._forceCompany = data["COMPANY_ID"];
	  }
  }

	public doAddCompany(): void {
		this.runModalDialog(UserAddMinicompanyComponent,
			(result:any) => {
				// Nothing.
			},
			(reason:any) => {
				// Adding a new company.
				var companyFound = false;
				for (var idx in this.companies) {
					if (this.companies[idx]._id == "---"+reason) {
						companyFound = true;
						break;
					}
				}
				if (!companyFound) {
					this.companies.push({_id:"---"+reason, name: reason});
				
					// Sorting the new list.
					this.companies.sort((element1, element2) => {
						if (element1.name < element2.name) return -1;
						if (element1.name > element2.name) return 1;

						return 0;
					});

					// Selecting the new company.
					this.userAddForm.controls["companyControl"].setValue("---"+reason);
				}
			}
		);
	}

	public save(): void {
		// Disabling button.
		this.buttonText = "Veuillez patienter ...";
		this.enableAction = false;

		var newData = {
			"username": this.userAddForm.controls['usernameControl'].value,
			"role": this.userAddForm.controls['roleControl'].value,
			"name": this.userAddForm.controls['nameControl'].value,
			"firstname": this.userAddForm.controls['firstnameControl'].value,
			"company": this.userAddForm.controls['companyControl'].value
		};

		this.put("/api/user-add", newData, 
			(response: any) => {
				if (response.DATA == "ERR") {
					this.modalInstance.close(response.VALUE);
				} else {
					// Inserting the new element in the list.
					var newUser = {
						_id: response.ID,
						username: newData["username"].trim(),
						role: newData["role"],
						active: true,
						global_active: "A",
						name: newData["name"].toUpperCase().trim(),
						firstname: newData["firstname"].charAt(0).toUpperCase() + newData["firstname"].slice(1).trim(),
						company_id: newData["company"],
						company_name: response.COMPANY_NAME
					};
					// Updating the company_id if the company is new.
					if (newData["company"].startsWith("---")) {
						newUser["company_id"] = response.COMPANY_ID;
					}
					this.modalInstance.dismiss(newUser);
				}
			},
			(err: any) => {
				this.modalInstance.close(err);
			}
		);
	}
}
